<template>
  <!-- <div> -->
  <div ref="containerRef" class="j_filter" :class="[$style.filter]">
    <ul :class="$style.filterBar">
      <li v-for="tab in tabs" :key="tab.value"
        :class="[$style.filterItem, isActive(tab.value) ? $style.isActive : '', hasValues(tab.paths) ?  $style.isHighlight : '']"
        @click="onChangeActive(tab)">
        <span>{{tab.text}}</span>
        <i :class="$style.filterItem__icon" class="el-icon-caret-bottom" />
      </li>
      <li v-if="isLimit" class="ml-auto px-5">
        <button class="text-primary" @click="onReset">清除筛选</button>
      </li>
    </ul>
    <transition name="el-fade-in-linear">
      <div v-show="showPopover" :class="$style.filterPanels">
        <index-filter-brand v-if="isActive('brand')" :default-data="searchData" @close="activeTab = null" @confirm="onConfirm" />
        <index-filter-type v-if="isActive('type')" :default-data="searchData" @close="activeTab = null" @confirm="onConfirm" />
        <index-filter-status v-if="isActive('status')" :default-data="searchData" @close="activeTab = null" @confirm="onConfirm" />
        <index-filter-other v-if="isActive('other')" :default-data="searchData" @close="activeTab = null" @confirm="onConfirm" />
      </div>
    </transition>
  </div>
</template>
<script>
import { computed, defineComponent, ref } from "@nuxtjs/composition-api";
import IndexFilterBrand from "./index-filter-brand.vue";
import IndexFilterStatus from "./index-filter-status.vue";
import IndexFilterOther from "./index-filter-other.vue";
import IndexFilterType from "./index-filter-type.vue";
import { onClickOutside, useElementBounding } from "@vueuse/core";
import { isEmpty } from "lodash";
import { omit, get } from "lodash";

export default defineComponent({
	name: "IndexFilter",
	components: {
		IndexFilterBrand,
		IndexFilterStatus,
		IndexFilterType,
		IndexFilterOther
	},
	props: {
		searchData: Object
	},
	emits: ["confirm", "reset"],
	setup(props, { emit }) {
		// const modelSearchData = useVModel(props, 'searchData', emit)
		const containerRef = ref();
		const { width } = useElementBounding(containerRef);
		const popoverOptions = computed(() => ({
			boundariesPadding: 48
		}));

		const tabs = ref([
			{ text: "船舶公司", value: "brand", paths: ["company_id"] },
			{ text: "船舶类型", value: "type", paths: ["class_id"] },
			{ text: "航行状态", value: "status", paths: ["navistatus"] },
			{
				text: "更多选择",
				value: "other",
				paths: [
					"first_flight_time_end",
					"first_flight_time_start",
					"renovation_time_end",
					"renovation_time_start",
					"tonnage"
				]
			}
		]);
		const activeTab = ref(null);

		const showPopover = computed(() => !!activeTab.value);

		function onChangeActive(tab) {
			if (isActive(tab.value)) {
				activeTab.value = null;
			} else {
				activeTab.value = tab;
			}
		}

		function isActive(tabKey) {
			return activeTab.value && tabKey === activeTab.value.value;
		}

		function onConfirm(params) {
			emit("confirm", params);
			activeTab.value = null;
			// showPopover.value = false;
		}

		function onReset() {
			activeTab.value = null;
			emit("reset");
		}

		const isLimit = computed(() => {
			const values = Object.values(omit(props.searchData, 'keyword')).map((item) =>
				isEmpty(item)
			);
			return !isEmpty(values.filter((item) => !item));
		});

		function hasValues(paths) {
			return (
				paths
					.map((path) => get(props.searchData, path))
					.filter((value) => !isEmpty(value)).length > 0
			);
		}

		onClickOutside(containerRef, () => (activeTab.value = null));
		// const {} = useOut
		return {
			containerRef,
			containerWidth: width,
			popoverOptions,
			tabs,

			showPopover,
			activeTab,
			onChangeActive,
			isActive,

			isLimit,
			hasValues,

			onConfirm,
			onReset
		};
	}
});
</script>
<style lang="scss" module>
.filter {
  position: absolute;
  top: 3rem;
  left: 29.25rem;
  z-index: 10;
}
.filter .filterBar {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}
.filterItem {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  cursor: pointer;
  height: 3rem;
  line-height: 3rem;
  padding-left: 1.25rem;
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.filterItem:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.filterItem:first-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.filterItem:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.filterItem.isActive {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.filterItem.isActive .filterItem__icon {
  --tw-rotate: 180deg;
}
.filterItem.isHighlight {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.filterItem__icon {
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -webkit-transition-property: -webkit-transform;
  -o-transition-property: transform;
  transition-property: transform, -webkit-transform;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.filterPanels {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  margin-top: 0.625rem;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 100%;
  width: 34.5rem;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}
</style>